import { render, staticRenderFns } from "./CandidateNotes.vue?vue&type=template&id=573ba1eb&"
import script from "./CandidateNotes.vue?vue&type=script&lang=js&"
export * from "./CandidateNotes.vue?vue&type=script&lang=js&"
import style0 from "./CandidateNotes.vue?vue&type=style&index=0&id=573ba1eb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports